import { api } from './client';
import type { CharacterCustomEffect, AddCustomEffectRequest, UpdateCustomEffectRequest } from '@charbuilder/shared';

export async function addCustomEffect(characterId: string, dto: AddCustomEffectRequest): Promise<CharacterCustomEffect> {
  const { data } = await api.post(`/characters/${characterId}/custom-effects`, dto);
  return data;
}

export async function updateCustomEffect(
  characterId: string,
  effectId: string,
  dto: UpdateCustomEffectRequest,
): Promise<CharacterCustomEffect> {
  const { data } = await api.patch(`/characters/${characterId}/custom-effects/${effectId}`, dto);
  return data;
}

export async function deleteCustomEffect(characterId: string, effectId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/custom-effects/${effectId}`);
}

export async function deleteAllCustomEffects(characterId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/custom-effects`);
}
